// extracted by mini-css-extract-plugin
module.exports = {"Button":"Toolbar_Button__2IkOM","Range":"Toolbar_Range__3-wg2","ButtonActive":"Toolbar_ButtonActive__lPatz"};